import Rule from './rule';

export default class ListRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
    this.ruleType = 'LIST';
    this._isPickList = false;
    this.compile(ruleText);
  }

  compile(text) {
    const rule = text.replace(/^\s?list/i, '');
    this.args = rule.split(',').map(item => item.trim());
    if (this.args[0].toLowerCase() === '--auto') {
      this._isPickList = true;
      this.args.shift();
    }
  }

  run(input) {
    if (this._isPickList) {
      return input;
    }
    return this.args.includes(input) ? input : '';
  }

  validate() {
    return this._isPickList || (!!this.args[0] && this.args.length > 1);
  }

  get isPickList() {
    return this._isPickList;
  }
}
